import { render, staticRenderFns } from "./BannerCreate.vue?vue&type=template&id=06263a9f&"
import script from "./BannerCreate.vue?vue&type=script&lang=js&"
export * from "./BannerCreate.vue?vue&type=script&lang=js&"
import style0 from "./BannerCreate.vue?vue&type=style&index=0&id=06263a9f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports